import PluginSetup from './plugins/PluginSetup'

export default {
  install( molten ) {
    PluginSetup.install( molten )
  },
}
